function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "./Configuration";
export var I18N = /*#__PURE__*/function () {
  function I18N(componentName) {
    _classCallCheck(this, I18N);

    this._componentName = componentName;
    this._locale = I18N.GetCurrentLocale();
    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
    return fetch("".concat(this._appRoot, "/Api/ConfigurationApi/GetLabels?componentName=").concat(this._componentName, "&locale=").concat(this._locale), {
      credentials: "include",
      mode: "cors",
      withCredentials: true
    }).then(function (response) {
      return response.json();
    });
    /*
    	.catch((a, b) => {
    		//TODO: Write this error into HTML:
    		console.log("a", a);
    		//console.log("b", b);
    		var h = this; //.getRootNode().host;
    		console.log("h", h);
    		this.parentNode.innerHTML = `Error: ${a}`;
    });
    */
  }

  _createClass(I18N, null, [{
    key: "GetCurrentLocale",
    value: function GetCurrentLocale() {
      return localStorage.userLocale || "en";
    }
  }]);

  return I18N;
}();